export const INTERESTS = [
  "✈️ Voyage", "🎵 Musique", "🍳 Cuisine", "⚽ Sport", "🎬 Cinéma",
  "📚 Lecture", "💃 Danse", "🏋️ Fitness", "🌿 Nature", "📸 Photographie",
  "🎮 Jeux vidéo", "🎨 Art", "👗 Mode", "⚽ Football", "🙏 Spiritualité",
  "💼 Entrepreneuriat", "🐶 Animaux", "🎤 Concerts", "🥾 Randonnée", "☕ Sorties entre amis",
];

export const PARTNER_VALUES = [
  "Honnêteté", "Respect", "Humour", "Ambition", "Fidélité",
  "Famille", "Foi", "Gentillesse", "Communication", "Maturité",
  "Bienveillance", "Empathie", "Sincérité", "Loyauté", "Ouverture d'esprit",
  "Intelligence", "Optimisme", "Romantisme", "Sens des responsabilités", "Tolérance",
];

export const MAX_INTERESTS = 8;
export const MIN_INTERESTS = 3;
export const MAX_VALUES = 5;

export const COUNTRIES = ["Afrique du Sud", "Algérie", "Angola", "Bénin", "Botswana", "Burkina Faso", "Burundi", "Cameroun", "Cap-Vert", "Comores", "Congo (Brazzaville)", "Congo (RDC)", "Côte d'Ivoire", "Djibouti", "Égypte", "Érythrée", "Eswatini", "Éthiopie", "Gabon", "Gambie", "Ghana", "Guinée", "Guinée-Bissau", "Guinée équatoriale", "Kenya", "Lesotho", "Libéria", "Libye", "Madagascar", "Malawi", "Mali", "Maroc", "Maurice", "Mauritanie", "Mozambique", "Namibie", "Niger", "Nigéria", "Ouganda", "République centrafricaine", "Rwanda", "Sao Tomé-et-Principe", "Sénégal", "Seychelles", "Sierra Leone", "Somalie", "Soudan", "Soudan du Sud", "Tanzanie", "Tchad", "Togo", "Tunisie", "Zambie", "Zimbabwe"];

export const RESIDENCE_COUNTRIES = ["France", "Belgique", "Suisse", "Luxembourg", "Allemagne", "Royaume-Uni", "Irlande", "Italie", "Espagne", "Portugal", "Pays-Bas", "Suède", "Norvège", "Danemark", "Finlande", "Autriche", "Grèce", "États-Unis", "Chine", "Canada", "Algérie", "Bénin", "Burkina Faso", "Burundi", "Cameroun", "Comores", "Congo (Brazzaville)", "Congo (RDC)", "Côte d'Ivoire", "Djibouti", "Gabon", "Guinée", "Guinée équatoriale", "Madagascar", "Mali", "Maroc", "Maurice", "Mauritanie", "Niger", "République centrafricaine", "Rwanda", "Sénégal", "Seychelles", "Tchad", "Togo", "Tunisie"];

export const LANGUAGES = [
  { value: "francais", label: "Français", emoji: "🇫🇷" },
  { value: "anglais", label: "Anglais", emoji: "🇬🇧" },
  { value: "les-deux", label: "Français et Anglais", emoji: "🌍" },
];

// ---- Informations personnelles ----
export const HAS_CHILDREN = [
  { value: "oui", label: "Oui", emoji: "👶" },
  { value: "non", label: "Non", emoji: "🚫" },
];
export const CHILDREN_COUNT = [
  { value: "1", label: "1", emoji: "👶" },
  { value: "2", label: "2", emoji: "👧" },
  { value: "3", label: "3", emoji: "👦" },
  { value: "4+", label: "4 et plus", emoji: "👨‍👩‍👧‍👦" },
];
export const WANTS_CHILDREN = [
  { value: "oui", label: "Oui", emoji: "👶" },
  { value: "non", label: "Non", emoji: "❌" },
  { value: "peut-etre", label: "Peut-être", emoji: "🤔" },
  { value: "peu-importe", label: "Peu importe", emoji: "😊" },
];
export const MARITAL_STATUS = [
  { value: "celibataire", label: "Célibataire", emoji: "💚" },
  { value: "divorce", label: "Divorcé(e)", emoji: "💔" },
  { value: "veuf", label: "Veuf / Veuve", emoji: "🕊️" },
  { value: "separe", label: "Séparé(e)", emoji: "🤝" },
  { value: "marie", label: "Marié(e)", emoji: "💍" },
  { value: "complique", label: "C'est compliqué", emoji: "🌀" },
];
export const SMOKING = [
  { value: "non", label: "Non, jamais", emoji: "🚭" },
  { value: "occasionnel", label: "Occasionnellement", emoji: "🚬" },
  { value: "oui", label: "Oui, régulièrement", emoji: "🚬" },
  { value: "arrete", label: "J'ai arrêté", emoji: "🔄" },
];
export const ALCOHOL = [
  { value: "jamais", label: "Jamais", emoji: "🚫" },
  { value: "occasionnel", label: "Occasionnellement", emoji: "🍷" },
  { value: "evenements", label: "Lors d'événements", emoji: "🥂" },
  { value: "regulier", label: "Régulièrement", emoji: "🍺" },
];

const ALL_PERSONAL = {
  has_children: HAS_CHILDREN,
  children_count: CHILDREN_COUNT,
  wants_children: WANTS_CHILDREN,
  marital_status: MARITAL_STATUS,
  smoking: SMOKING,
  alcohol: ALCOHOL,
  languages: LANGUAGES,
};

export const personalLabel = (key, value) => {
  const opt = (ALL_PERSONAL[key] || []).find((o) => o.value === value);
  return opt ? `${opt.emoji} ${opt.label}` : null;
};
